var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleDisplayDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.47c-.7-.05-1.43.11-2.08.49a3.656 3.656 0 00-1.35 5l7.34 12.7c1.01 1.76 3.25 2.34 5.01 1.34 1.75-1 2.33-3.25 1.33-5L15.18 3.3a3.695 3.695 0 00-2.93-1.83M6.82 6.76L1.5 16a3.67 3.67 0 00-.5 1.83 3.67 3.67 0 003.67 3.67 3.67 3.67 0 003.17-1.84v.01L11 14.19c-1.35-2.3-2.73-4.59-3.97-6.96-.08-.15-.15-.31-.2-.47zL16.4 5z"
  })));
}
export default SvgGoogleDisplayDark;